// 5th Anniversary revamp pages (src/revamp) — rendered inside RevampShell, see RoutesRevamp below
import RevampHome from "../revamp/pages/home";
import RevampAbout from "../revamp/pages/about";
import RevampContactUs from "../revamp/pages/contact-us";
import RevampEvents from "../revamp/pages/events";
import RevampFaq from "../revamp/pages/faq";
import RevampFindAMentor from "../revamp/pages/find-a-mentor";
import RevampForOrganisations from "../revamp/pages/for-organisations";
import RevampHowItWorks from "../revamp/pages/how-it-works";
import RevampMentorLookUp from "../revamp/pages/mentorlookup";
import RevampResources from "../revamp/pages/resources";
import { lazy } from "react";

// Partner programme pages, restyled to the theme (same logic/endpoints as the
// old src/Pages/MentorSCS, MentorIgnite and UMentor they replace). They stay in
// RoutesPage: scs-wit renders bare (partner whitelist in src/Pages/index.js),
// the other two get the LegacyShell header/footer.
const RevampScsWit = lazy(() => import("../revamp/pages/partner-mentoring/scs-wit"));
const RevampIgnite = lazy(() => import("../revamp/pages/partner-mentoring/ignite"));
const RevampUMentor = lazy(() => import("../revamp/pages/partner-mentoring/u-mentor"));

// CMS Page Routes
const Home = lazy(() => import("../Pages/Home"));
// import AboutUs from "../Pages/AboutUs";  // old page — replaced by RoutesRevamp
const AboutUsApp = lazy(() => import("../Pages/AboutUsApp"));
const Organisation = lazy(() => import("../Pages/Organisation"));
const Partnerships = lazy(() => import("../Pages/Partnerships"));
const PartnershipsApp = lazy(() => import("../Pages/PartnershipsApp"));
// import Faq from "../Pages/Faq";  // old page — replaced by RoutesRevamp
const FaqApp = lazy(() => import("../Pages/FaqApp"));
// import ContactUs from "../Pages/ContactUs";  // old page — replaced by RoutesRevamp
// import Mentors from "../Pages/Mentors";  // old page — replaced by RoutesRevamp
const MentorDoid = lazy(() => import("../Pages/MentorDoid"));
// import MentorIgnite from "../Pages/MentorIgnite";  // old page — replaced by RevampIgnite
const Cms = lazy(() => import("../Pages/CMS"));
// import Program from "../Pages/Program";
// import Programs from "../Pages/Programs";  // old page — replaced by RoutesRevamp
// import Saas from "../Pages/Saas";  // old page — replaced by RoutesRevamp

//Auth Routes
const Login = lazy(() => import("../Pages/Authentication/SignIn"));
const ForgotPassword = lazy(() => import("../Pages/Authentication/ForgotPassword"));
const RestPassword = lazy(() => import("../Pages/Authentication/RestPassword"));
const Register = lazy(() => import("../Pages/Authentication/Register"));
const StudentSignUp = lazy(() => import("../Pages/StudentSignUp/StudentSignup"));
const StudentSignUp2 = lazy(() => import("../Pages/StudentSignUp/StudentSignup2"));
const StudentSignUp3 = lazy(() => import("../Pages/StudentSignUp/StudentSignup3"));
const StudentSignUp4 = lazy(() => import("../Pages/StudentSignUp/StudentSignup4"));
// import StudentSignUp11 from "../Pages/StudentSignUp/StudentSignup11";
const MentorSignUp = lazy(() => import("../Pages/MentorSignUp/MentorSignUp"));
const MentorSignUp2 = lazy(() => import("../Pages/MentorSignUp/MentorSignUp2"));
const MentorSignUp3 = lazy(() => import("../Pages/MentorSignUp/MentorSignUp3"));
const MentorSignUp4 = lazy(() => import("../Pages/MentorSignUp/MentorSignUp4"));

// After login
const MentorListing = lazy(() => import("../Pages/MentorListing"));
const MenteeListing = lazy(() => import("../Pages/MenteeListing"));
const Dashboard = lazy(() => import("../Pages/Dashboard"));
const CurrentMentees = lazy(() => import("../Pages/MentorDashboard1"));
const SuggestedMentor = lazy(() => import("../Pages/MenteeDashboard"));
const UpdateProfile = lazy(() => import("../Pages/UpdateProfile/UpdateProfile1"));
const UpdateProfile2 = lazy(() => import("../Pages/UpdateProfile/UpdateProfile2"));
const UpdateProfile3 = lazy(() => import("../Pages/UpdateProfile/UpdateProfile3"));
const UpdateProfile4 = lazy(() => import("../Pages/UpdateProfile/UpdateProfile4"));
const Password = lazy(() => import("../Pages/Password"));
const MenteeRequest = lazy(() => import("../Pages/MenteesRequest"));
const MyMentors = lazy(() => import("../Pages/MyMentors"));
const PendingMenterRequest = lazy(() => import("../Pages/PendingMenterRequest"));
const MenteesLog = lazy(() => import("../Pages/MenteesLog"));
const Availability = lazy(() => import("../Pages/Availability"));
const Chat = lazy(() => import("../Pages/Chat"));
const Resourcehub = lazy(() => import("../Pages/Resourcehub/ResourcesHub"));
const PostResourcehub = lazy(() => import("../Pages/Resourcehub/PostResourcesHub"));
const ResourcesDetail = lazy(() => import("../Pages/ResourcesDetail"));
const DeleteProfile = lazy(() => import("../Pages/DeleteProfile/DeleteProfile"));
const CommunityDetail = lazy(() => import("../Pages/CommunityDetail"));
const MyDiagnosticToolkit = lazy(() => import("../Pages/MyDiagnosticToolkit"));
const Refer = lazy(() => import("../Pages/Refer"));
// Forum removed per QA (Testing sheet row 2, 31 Aug) — pages kept on disk.
// import Forum from "../Pages/Forum";
// import ForumTest from "../Pages/Forum/forumtest";
const GrowWithUs = lazy(() => import("../Pages/GrowWithUs"));

const CKEditorFileUpload = lazy(() => import("../Pages/CKEditorFileUpload"));

//Events
// import Event from "../Pages/Event";  // old page — replaced by RoutesRevamp
const EventDetail = lazy(() => import("../Pages/Event/detail"));
// import Newsletter from "../Pages/Resourcehub/Newsletter";  // old page — replaced by RoutesRevamp
const NewsletterApp = lazy(() => import("../Pages/Resourcehub/NewsletterApp"));
// import Videos from "../Pages/Resourcehub/Video";  // old page — replaced by RoutesRevamp
const PreRegistrationFrom = lazy(() => import("../Pages/PreRegistrationFrom"));
const Certificate = lazy(() => import("../Pages/Certificate"));
// import ScheduleListing from "../Pages/ScheduleListing";
const ScheduleListingCalendar = lazy(() => import("../Pages/ScheduleListingCalendar"));
// import MentorSCS from "../Pages/MentorSCS";  // old page — replaced by RevampScsWit
// import UMentor from "../Pages/UMentor";  // old page — replaced by RevampUMentor

export const preloadDashboardRoutes = () => {
  if (typeof window === "undefined") return;
  const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1000));
  idle(() => {
    import("../Pages/Dashboard").catch(() => { });
    import("../Pages/MentorDashboard1").catch(() => { });
    import("../Pages/MenteeDashboard").catch(() => { });
    import("../Pages/Certificate").catch(() => { });
    import("../Pages/UpdateProfile/UpdateProfile1").catch(() => { });
    import("../Pages/Availability").catch(() => { });
    import("../Pages/ScheduleListingCalendar").catch(() => { });
    import("../Pages/Chat").catch(() => { });
    import("../Pages/Refer").catch(() => { });
    import("../Pages/DeleteProfile/DeleteProfile").catch(() => { });
    import("../Pages/MyDiagnosticToolkit").catch(() => { });
    import("../Pages/MenteesRequest").catch(() => { });
    import("../Pages/PendingMenterRequest").catch(() => { });
    import("../Pages/MyMentors").catch(() => { });
  });
};

// Revamp routes: new shell (header/footer from src/revamp), no old Header/Footer.
// Addresses stay the live ones (plan decision 4); the design's hrefs are mapped in src/revamp/lib/routes.js.
export const RoutesRevamp = [
  { path: "/", name: "Home", component: RevampHome, title: "vLookUp" },
  { path: "/how-it-works", name: "HowItWorks", component: RevampHowItWorks, title: "How it Works" },
  { path: "/aboutus", name: "AboutUs", component: RevampAbout, title: "About Us" },
  { path: "/contact-us", name: "ContactUs", component: RevampContactUs, title: "Contact Us" },
  { path: "/event/:type", name: "Events", component: RevampEvents, title: "Events" },
  { path: "/faq", name: "Faq", component: RevampFaq, title: "FAQ" },
  { path: "/mentors", name: "Mentors", component: RevampFindAMentor, title: "Find a Mentor" },
  { path: "/programs", name: "Programs", component: RevampForOrganisations, title: "For Organisations" },
  { path: "/saas", name: "Saas", component: RevampMentorLookUp, title: "MentorLookUp" },
  { path: "/resource-hub/:slug?", name: "Resources", component: RevampResources, title: "Resources" },
  { path: "/newsletter", name: "Newsletter", component: RevampResources, title: "Newsletters" },
  { path: "/videos", name: "Videos", component: RevampResources, title: "Videos" },
];

export const RoutesPage = [
  // Old home page, kept only for side-by-side comparison during the revamp review. Remove before release.
  { path: "/home-legacy", name: "Home", component: Home, title: "vLookUp" },
  // replaced by RoutesRevamp: {
  // path: "/mentors",
  // name: "Mentors",
  // component: Mentors,
  // title: "Mentors",
  // },
  {
    path: "/mahadewi-mentoring",
    name: "Mentors",
    component: MentorDoid,
    title: "Mentors",
  },
  {
    path: "/scs-wit-mentoring",
    name: "Mentors",
    component: RevampScsWit,
    title: "Mentors",
  },
  {
    path: "/ignite-women-mentoring",
    name: "Mentors",
    component: RevampIgnite,
    title: "Mentors",
  },
  // replaced by RoutesRevamp: {
  // path: "/aboutus",
  // name: "aboutus",
  // component: AboutUs,
  // title: "vLookUp | Helping women grow and lea",
  // },
  {
    path: "/organisations",
    name: "organisations",
    component: Organisation,
    title: "Partners and Organisations",
  },
  // replaced by RoutesRevamp: {
  // path: "/faq",
  // name: "Faq",
  // component: Faq,
  // title: "FAQ's",
  // },

  {
    path: "/partnerships",
    name: "partnerships",
    component: Partnerships,
    title: "Partnerships",
  },
  // replaced by RoutesRevamp: {
  // path: "/programs",
  // name: "Programs",
  // component: Programs,
  // title: "Programs",
  // },
  // replaced by RoutesRevamp: {
  // path: "/saas",
  // name: "Saas",
  // component: Saas,
  // title: "Saas",
  // },
  {
    path: "/u-mentor",
    name: "U-Mentor",
    component: RevampUMentor,
    title: "U-Mentor",
  },
  // replaced by RoutesRevamp: {
  // path: "/contact-us",
  // name: "Contact Us",
  // component: ContactUs,
  // title: "Contact Us",
  // },
  // replaced by RoutesRevamp: {
  // path: "/resource-hub/:slug",
  // name: "Resourcehub",
  // component: Resourcehub,
  // title: "Resourcehub",
  // },
  // replaced by RoutesRevamp: {
  // path: "/resource-hub",
  // name: "Resourcehub",
  // component: Resourcehub,
  // title: "Resourcehub",
  // },
  // replaced by RoutesRevamp: {
  // path: "/newsletter",
  // name: "Newsletter",
  // component: Newsletter,
  // title: "Newsletter",
  // },
  // replaced by RoutesRevamp: {
  // path: "/videos",
  // name: "Video",
  // component: Videos,
  // title: "Video",
  // },
  {
    path: "/post-resource-hub",
    name: "PostResourcehub",
    component: PostResourcehub,
    title: "PostResourcehub",
  },
  {
    path: "/resources-details/:slug",
    name: "ResourcesDetail",
    component: ResourcesDetail,
    title: "ResourcesDetail",
  },
  {
    path: "/resources-details",
    name: "Resourcehub",
    component: Resourcehub,
    title: "Resourcehub",
  },
  {
    path: "/community-details/:slug",
    name: "CommunityDetail",
    component: CommunityDetail,
    title: "CommunityDetail",
  },
  {
    path: "/page/:slug",
    name: "PrivacyPolicy",
    component: Cms,
    title: "Privacy Policy",
  },
  {
    path: "/uploader/upload",
    name: "FileUpload",
    component: CKEditorFileUpload,
    title: "File Upload",
  },
  // replaced by RoutesRevamp: {
  // path: "/event/:type",
  // name: "Event",
  // component: Event,
  // title: "Event",
  // },
  {
    path: "/event-detail/:slug",
    name: "EventDetail",
    component: EventDetail,
    title: "Event Detail",
  },
];

export const RoutesAuth = [
  {
    path: "/login",
    name: "Login",
    component: Login,
    title: "Login",
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
    title: "Register",
  },
  {
    path: "/aboutusapp",
    name: "AboutUsApp",
    component: AboutUsApp,
    title: "About Us",
  },
  {
    path: "/faqapp",
    name: "faqapp",
    component: FaqApp,
    title: "FAQ's",
  },
  {
    path: "/partnershipsapp",
    name: "partnershipsapp",
    component: PartnershipsApp,
    title: "Partnerships",
  },

  // {
  //   path: "/program",
  //   name: "Program",
  //   component: Program,
  //   title: "Program",
  // },

  {
    path: "/newsletterapp/:slug",
    name: "NewsletterApp",
    component: NewsletterApp,
    title: "Newsletter",
  },
  {
    path: "/mentee-signup-step-1",
    name: "StudentSignUp",
    component: StudentSignUp,
    title: "StudentSignUp",
  },
  // {
  //   path: "/mentee-signup-step-11",
  //   name: "StudentSignUp 1",
  //   component: StudentSignUp11,
  //   title: "StudentSignUp 1",
  // },
  {
    path: "/mentee-signup-step-2",
    name: "StudentSignUp step 2",
    component: StudentSignUp2,
    title: "StudentSignUp step 2",
  },
  {
    path: "/mentee-signup-step-3",
    name: "StudentSignUp step 3",
    component: StudentSignUp3,
    title: "StudentSignUp step 3",
  },
  {
    path: "/mentee-signup-step-4",
    name: "StudentSignUp4",
    component: StudentSignUp4,
    title: "StudentSignUp4",
  },

  {
    path: "/mentor-signup-step-1",
    name: "MentorSignUp",
    component: MentorSignUp,
    title: "MentorSignUp",
  },
  {
    path: "/mentor-signup-step-2",
    name: "MentorSignUp step 2",
    component: MentorSignUp2,
    title: "MentorSignUp step 2",
  },
  {
    path: "/mentor-signup-step-3",
    name: "MentorSignUp step 3",
    component: MentorSignUp4,
    title: "MentorSignUp step 3",
  },
  {
    path: "/mentor-signup-step-4",
    name: "MentorSignUp4",
    component: MentorSignUp3,
    title: "MentorSignUp4",
  },

  {
    path: "/forgotPassword",
    name: "ForgotPassword",
    component: ForgotPassword,
    title: "Forgot Password",
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPassword,
    title: "Forgot Password",
  },
  {
    path: "/reset-password",
    name: "Rest Password",
    component: RestPassword,
    title: "Rest Password",
  },
  {
    path: "/pre-registration-form",
    name: "Pre Registration From",
    component: PreRegistrationFrom,
    title: "Pre Registration From",
  },
];

export const RoutesUser = [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    title: "Dashboard",
  },
  {
    path: "/current-mentees",
    name: "CurrentMentees",
    component: CurrentMentees,
    title: "Current Mentees",
  },
  // {
  //   path: "/schedule-meeting",
  //   name: "ScheduleListing",
  //   component: ScheduleListing,
  //   title: "Schedule Listing",
  // },
  {
    path: "/schedule-meeting-calendar",
    name: "ScheduleListingCalendar",
    component: ScheduleListingCalendar,
    title: "Calendar/Meetings",
  },
  {
    path: "/suggested-mentors",
    name: "SuggestedMentor",
    component: SuggestedMentor,
    title: "Suggested Mentors",
  },
  {
    path: "/dashboard-mentors",
    name: "MentorsListing",
    component: MentorListing,
    title: "MentorsListing",
  },
  {
    path: "/mentees-listing",
    name: "MenteeListing",
    component: MenteeListing,
    title: "MenteeListing",
  },
  {
    path: "/manage-profile",
    name: "ManageProfile",
    component: UpdateProfile,
    title: "ManageProfile",
  },
  {
    path: "/manage-profile-step2",
    name: "ManageProfile-step2",
    component: UpdateProfile2,
    title: "ManageProfile-step2",
  },
  {
    path: "/manage-profile-step3",
    name: "ManageProfile-step3",
    component: UpdateProfile3,
    title: "ManageProfile-step3",
  },
  {
    path: "/manage-profile-step4",
    name: "ManageProfile-step4",
    component: UpdateProfile4,
    title: "ManageProfile-step4",
  },
  {
    path: "/change-password",
    name: "change-password",
    component: Password,
    title: "change-password",
  },
  {
    path: "/mantees-request", // path kept (bookmarks/deep links); QA row 27 fixed the visible text only
    name: "Mentee Requests",
    component: MenteeRequest,
    title: "Mentee Requests",
  },
  {
    path: "/my-mentors",
    name: "my-mentors",
    component: MyMentors,
    title: "my-mentors",
  },
  {
    path: "/pending-mentors",
    name: "pending-mentors",
    component: PendingMenterRequest,
    title: "pending-mentors",
  },
  {
    path: "/mentees-logs",
    name: "mentees-logs",
    component: MenteesLog,
    title: "mentees-logs",
  },
  {
    path: "/my-diagnostic-toolkit",
    name: "my-diagnostic-toolkit",
    component: MyDiagnosticToolkit,
    title: "My Self Assessment",
  },
  {
    path: "/certificate",
    name: "certificate",
    component: Certificate,
    title: "Certificate",
  },
  {
    path: "/availability",
    name: "Availability",
    component: Availability,
    title: "Availability",
  },
  {
    path: "/chat",
    name: "Chat",
    component: Chat,
    title: "Chat",
  },
  {
    path: "/delete-my-profile",
    name: "DeleteProfile",
    component: DeleteProfile,
    title: "Delete Profile",
  },
  {
    path: "/refer",
    name: "Refer",
    component: Refer,
    title: "Refer vLookUp",
  },
  // Forum routes removed per QA (Testing sheet row 2, 31 Aug):
  // {
  //   path: "/forum",
  //   name: "Forum",
  //   component: Forum,
  //   title: "vLookUp Forum",
  // },
  // {
  //   path: "/forumtest",
  //   name: "Forum",
  //   component: ForumTest,
  //   title: "vLookUp Forum",
  // },

  {
    path: "/grow-with-us",
    name: "Grow With Us",
    component: GrowWithUs,
    title: "vLookUp Grow",
  },
];
